import { styled } from '@mui/system'
import FormControl from '@mui/material/FormControl'
import { RadioGroup } from '@mui/material'
import PhoneInput from 'react-phone-input-2'

interface IFormLoginControl {
	readonly absoluteError?: boolean
}

const FormAppControl = styled(FormControl, {
	shouldForwardProp: prop => prop !== 'absoluteError',
})<IFormLoginControl>(({ theme, absoluteError }) => ({
	width: '100%',

	'& .Mui-error + .MuiFormControl-root .MuiSelect-select': {
		backgroundColor: theme.palette.error.light,

		'& ~.MuiOutlinedInput-notchedOutline': {
			borderColor: theme.palette.error.main,
		},
	},

	'& .MuiInputLabel-root': {
		color: '#3e3f4c',
		position: 'relative',
		fontFamily: 'Gilroy-Medium, sans-serif',
		fontWeight: 500,
		fontSize: '0.9375rem',
		transform: 'none',
		marginBottom: '0.25rem',
	},

	'& .MuiInputLabel-root.Mui-focused': {
		color: '#3e3f4c',
	},

	'& .MuiInputLabel-root.Mui-error': {
		color: '#d32f2f',

		'+ .react-tel-input .form-control': {
			borderColor: theme.palette.error.main,
			boxShadow: `0 0 0 1px ${theme.palette.error.main}`,

			'&:focus, &:hover': {
				borderColor: theme.palette.error.main,
				boxShadow: `0 0 0 1px ${theme.palette.error.main}`,
			},
		},

		'+ .MuiAutocomplete-root': {
			'& .MuiOutlinedInput-notchedOutline': {
				borderColor: theme.palette.error.main,
			},
		},
	},

	'& .MuiCircularProgress-root': {
		width: '1rem !important',
		height: '1rem !important',
	},

	'& .MuiInputBase-input': {
		position: 'relative',
		fontSize: '1rem',
		width: '100%',
		padding: '.625rem .9375rem .625rem .9375rem',
		fontWeight: 600,
		fontFamily: 'Gilroy-SemiBold, sans-serif',
		color: theme.palette.text.primary,
		'&::-ms-reveal': {
			display: 'none',
		},

		'&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
			WebkitAppearance: 'none',
			margin: 0,
		},

		'&[type=number]': {
			MozAppearance: 'textfield',
		},

		'&:focus': {
			boxShadow: 'none',
			borderColor: theme.palette.primary.main,
			color: theme.palette.text.primary,
		},
	},

	'& .MuiInputBase-root.Mui-error': {
		backgroundColor: theme.palette.error.light,
	},

	'& .MuiFormHelperText-root': {
		marginLeft: 0,
		bottom: '-1.2rem',
		...(absoluteError && { position: 'absolute' }),
	},

	'& .special-label': {
		display: 'none',
	},

	'& .react-tel-input .form-control': {
		width: '100%',
		fontSize: '0.9375rem',
		fontFamily: 'Gilroy-SemiBold, sans-serif',
		padding: ' 0.75rem 0.875rem 0.75rem 3.2rem',
		'&:focus': {
			borderColor: theme.palette.primary.main,
			boxShadow: `0 0 0 1px ${theme.palette.primary.main}`,
		},
	},
}))

const RadioGroupApp = styled(RadioGroup)`
	width: 350px;
	height: 44px;
	padding: 5px;
	border-radius: 10px;
	background-color: #f2f2f2;
	justify-content: space-between;
	.MuiFormControlLabel-label {
		display: none;
	}
	.MuiFormControlLabel-root {
		margin: 0;
	}
	.MuiRadio-root {
		padding: 0;
		border-radius: 10px;
	}
	.checed-icon {
		width: 160px;
		height: 34px;
		border-radius: 10px;
		box-shadow: 2px 2px 2px 0 rgba(77, 79, 87, 0.2);
		border: solid 1px rgba(23, 86, 100, 0.45);
		background-color: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.MuiTouchRipple-root {
		border-radius: 10px;
		width: 100%;
	}
	.MuiBox-root {
		width: 166px;
		height: 34px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
`

const PhoneInputDario = styled(PhoneInput)(() => ({
	'.dario-input': { background: 'red' },
}))

export { FormAppControl, RadioGroupApp, PhoneInputDario }
